import { ModelApiService } from './BaseApiService'

export default class PendingFeedbackApiServiceApiService extends ModelApiService {
  constructor() {
    super('feedbacks')
  }

  async getPendingFeedbacks(clientID) {
    return this.get(`getBookingsPendingFeedback?clientId=${clientID}`)
  }
}
